import { Popup as Modal } from 'reactjs-popup';
import Input from 'src/components/Input';
import Button from 'src/components/Button';
import Checkbox from 'src/components/Checkbox';
import { variables } from 'src/Tenants';
import React from 'react';

const GroupingModal = ({
  isOpen,
  onClose,
  acceptGroupLabelInput,
  groupLabel,
  onGroupLabelChange,
  onCreateNewGroup,
  showGroupServiceRequest,
  groupServiceRequestObj,
  selectedGroupId,
  onGroupSelect,
  onAddToGroup,
  selectedGroupServiceRequest,
  onShowGroupInput,
  onShowGroupSelection,
}: any) => (
  <Modal open={isOpen} modal onClose={onClose}>
    <div>
      <div style={{ textAlign: 'right' }}>
        <div className="filters_modal_top_coner_box">
          <div className="filters_modal_close_icon" onClick={onClose}>
            <svg
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.96 12.75L19.5 18.29V19.75H18.04L12.5 14.21L6.96 19.75H5.5V18.29L11.04 12.75L5.5 7.21V5.75H6.96L12.5 11.29L18.04 5.75H19.5V7.21L13.96 12.75Z"
                fill="black"
              />
            </svg>
          </div>
        </div>
      </div>
      <br />
      {acceptGroupLabelInput ? (
        <>
          <Input
            value={groupLabel}
            onChange={onGroupLabelChange}
            label="Group Label"
            placeholder="Enter Group Label.."
            block
            required
          />
          <Button
            color="teal"
            label="Create new group"
            size="tiny"
            onClick={onCreateNewGroup}
            disabled={!groupLabel}
          />
        </>
      ) : showGroupServiceRequest ? (
        <>
          {groupServiceRequestObj.map((data: any) => (
            <div key={data.id} style={{ flexDirection: 'row' }}>
              <Checkbox
                checked={selectedGroupId === data.id}
                name={selectedGroupId === data.id ? selectedGroupId : null}
                value={selectedGroupId === data.id ? selectedGroupId : ''}
                onClick={() => onGroupSelect(data)}
                readOnly
              />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span>{data.ticketNumber}</span>
              <br />
            </div>
          ))}
          <br />
          <Button
            color="teal"
            label={`Add ${variables.serviceRequest}`}
            size="tiny"
            onClick={() => onAddToGroup(selectedGroupId)}
            disabled={!selectedGroupServiceRequest}
          />
        </>
      ) : (
        <div style={{ alignItems: 'center', padding: 20 }}>
          <Button
            color="teal"
            label="Create new group"
            size="tiny"
            onClick={onShowGroupInput}
          />
          <br />
          <br />
          <Button
            color="teal"
            label="Add to existing group"
            size="tiny"
            onClick={onShowGroupSelection}
          />
        </div>
      )}
    </div>
  </Modal>
);

export default GroupingModal;
